<template>
  <v-layout justify-center>
    <v-flex xs12 sm10 md10>
      <v-layout>
        <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
          <v-select
            :items="searchSelect"
            v-model="searchType"
            label="Year"
            outline
            @change="searchYear"
          ></v-select>
        </v-flex>
        <v-flex xm12 md4 class="text-sm-center">
          <span class="headline">Mutton Bustin'</span><br />
          <span class="subheading"><i>{{ currentYear }}</i></span>
        </v-flex>
        <v-flex xm12 sm4 class="title text-sm-right">
          <v-tooltip bottom>
            <v-btn v-if="isCommChair" fab outline small color="primary" @click.stop="enterEvals" slot="activator">
              <v-icon dark>mdi-bullseye-arrow</v-icon>
            </v-btn>
            <span>Enter All Evals</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn v-if="isCommChair" fab outline small color="primary" slot="activator">
              <v-icon dark>mdi-cash-usd</v-icon>
            </v-btn>
            <span>Purchase Orders</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn fab outline small @click="buildPdf()" color="primary" slot="activator">
              <v-icon dark>mdi-file-document-outline</v-icon>
            </v-btn>
            <span>Policies and Proceedures</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn fab outline small color="primary" @click.stop="qrDialog = !qrDialog" slot="activator">
              <v-icon dark>mdi-qrcode-scan</v-icon>
            </v-btn>
            <span>Committee QR-Code</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn fab outline small color="primary" @click="buildEmail()" slot="activator" :disabled="!selected">
              <v-icon dark>email</v-icon>
            </v-btn>
            <span>Email Selected</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn v-if="isCommChair || isAdmin" fab outline small color="primary" slot="activator" @click="onExport()" :disabled="!selected">
              <v-icon>cloud_download</v-icon>
            </v-btn>
            <span>Download Selected</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <vue-good-table
        ref="my-table"
        styleClass="vgt-table striped bordered"
        :max-height=this.height
        :fixed-header="true"
        :isLoading=this.isTableLoading
        :columns="columns"
        :rows="rows"
        @on-cell-click="onCellClick"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true
        }"
        :search-options="{
          enabled: true
        }">
        <template slot="loadingContent">
          <div>
            <v-progress-circular
              :size="50"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
        </template>
        <div slot="table-actions-bottom">
          <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'fullName'">
            <v-layout align-center justify-start row fill-height>
              <v-flex sm9 md6 lg9>
                <div style="font-weight: bold;">{{ props.row.name }}<br/>({{ props.row.parents }})</div>
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'address'">
            <v-layout align-center justify-start row fill-height>
              <v-flex xs12>
                {{ props.row.address }}<br />{{ props.row.city }} {{ props.row.state }}, {{ props.row.zip }}
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'email'">
            <v-layout align-center justify-start row fill-height>
              <v-flex xs12>
                <a :href="'mailto:' + props.row.email" style="text-decoration: none;">
                  {{ props.row.email }}
                </a>
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'night'">
            <v-layout align-center justify-start row fill-height>
              <v-flex xs12>
                {{ props.row.night }}<br />
                {{ props.row.sheep }}
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'actions'">
            <div class="text-xs-center">
              <v-avatar
                v-if="isAdmin"
                color="blue lighten-4"
                class="mr-2 mt-2"
                size="30"
                style="cursor: pointer;"
                @click="editItem(props)"
              >
                <v-icon small>edit</v-icon>
              </v-avatar>
            </div>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
    </v-flex>

    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click="showEvalForm = !showEvalForm"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="viewDialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md6 order-xs2 order-md1>
                <v-flex xs12 class="text-xs-center text-sm-center">
                  <span class="headline">{{ editedItem.name }}</span><br />
                  <span class="subheading">({{ editedItem.title }})</span>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    v-if="editedItem.email"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="sendEmail"
                  >
                    Email {{editedItem.firstName}}
                    <v-icon right dark>email</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editedItem.cellPhone"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="callMobile"
                  >
                    Call Mobile
                    <v-icon right dark>mobile_screen_share</v-icon>
                  </v-btn>
                </v-flex>
              </v-flex>
              <v-flex xs12 md6 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <img :src="editedItem.picture" height="150" v-if="editedItem.image"/>
                <v-icon v-else x-large color="blue">person</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <EmailForm
      :visible="showEmailForm"
      :items="emailList"
      :selectedItems="emails"
      @close="closeThis"
    />

    <InternalForm
      :visible="showEvalForm"
      :item="evalItem"
      :committee="committeeHeader"
      :key="evalItem.id"
      persistent
      @close="closeThisEval"
    />

    <v-dialog v-model="dialog" max-width="500px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Member</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
            <v-btn dark flat @click="saveCommittee">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :items="memberList"
                  item-text="fullName"
                  item-value="id"
                  v-model="editedCommittee.userId"
                  label="Members"
                  hide-details
                  outline
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="memberTitles"
                  v-model="editedCommittee.title"
                  label="Title"
                  outline
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import VLazyImage from 'v-lazy-image'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import EmailForm from '../forms/EmailForm'
import InternalForm from './InternalForm.vue'
import QrcodeVue from 'qrcode.vue'
import moment from 'moment'
import XLSX from 'xlsx'

export default {
  components: {
    VueGoodTable,
    VLazyImage,
    EmailForm,
    InternalForm,
    QrcodeVue
  },
  data () {
    return {
      myId: this.$store.state.user.id,
      searchSelect: [],
      searchType: '',
      currentYear: 0,
      isAdmin: this.$store.state.isAdmin,
      isCommChair: false,
      dialog: false,
      croppa: {},
      qrDialog: false,
      size: 250,
      initialImage: null,
      dataURL: '',
      viewDialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      toggle_multiple: ['chair', 'assist', 'excel'],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Name (Parents)',
          field: 'fullName',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Age',
          field: 'age',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'WT',
          field: 'weight',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'DOB',
          field: 'birthDate',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Address',
          field: 'address',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Email',
          field: 'email',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Home',
          field: 'homePhone',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Mobile',
          field: 'cellPhone',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Night - Sheep',
          field: 'night',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      committeeHeader: {},
      rows: [],
      isLiason: false,
      liasons: [],
      exportFields: {
        'id': 'id',
        'Name': 'name',
        'Image': 'image',
        'Picture': 'picture',
        'Image File': 'imageFile',
        'Data Url': 'dataUrl',
        'Diet': 'diet',
        'Count': 'count'
      },
      editedItem: {
        index: 0,
        id: 0,
        name: ''

      },
      defaultItem: {
        index: 0,
        id: 0,
        name: ''
      },
      editedCommittee: {
        id: '',
        title: '',
        userId: 0,
        committeeId: 0
      },
      defaultCommittee: {
        id: '',
        title: '',
        userId: 0,
        committeeId: 0
      },
      evalItem: {},
      liason: {},
      showEmailForm: false,
      showEvalForm: false,
      emails: [],
      cc: [],
      bcc: [],
      emailList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      memberList: [],
      memberTitles: ['Chair', 'Co-Chair', 'Editor', 'Member', 'Volunteer']
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear
    this.searchType = this.$store.state.currentYear
    this.yearList()

    this.isCommChair = false
    this.isTableLoading = true

    if (this.$route.params.currentYear) {
      this.currentYear = this.$route.params.currentYear
    } else {
      this.currentYear = this.$store.state.currentYear
    }

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getMembers()
    this.getCommittees()

    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    '$route.params.committee': function (committee) {
      this.isTableLoading = true
      this.loading = true

      this.getCommittees()
      this.loading = false
    },

    dialog (val) {
      // this.$nextTick(this.$refs.focusItem.focus)
      val || this.close()
    },

    qrDialog (val) {
      val || this.close()
    }
  },

  methods: {
    yearList () {
      for (let i = this.$store.state.currentYear; i >= 2013; i--) {
        this.searchSelect.push(i)
      }
    },

    pickFile () {
      this.$refs.image.click()
    },

    onFilePicked (e) {
      const files = e.target.files

      if (files[0] !== undefined) {
        this.editedItem.image = files[0].name

        if (this.editedItem.image.lastIndexOf('.') <= 0) {
          return
        }

        const fr = new FileReader()
        fr.readAsDataURL(files[0])

        fr.addEventListener('load', () => {
          this.editedItem.picture = fr.result
          this.editedItem.imageFile = files[0]
        })
      } else {
        this.editedItem.image = ''
        this.editedItem.imageFile = ''
        this.editedItem.picture = ''
      }
    },

    async getMembers () {
      let allUsers = 'users'

      try {
        const response = await Api().get(allUsers)
        this.memberList = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    onCellClick (params) {
      if (params.column.field === 'fullName') {
        // console.log(params.row)
        this.editedItem.name = params.row.name
        this.editedItem.title = params.row.Title.name
        this.editedItem.firstName = params.row.firstName
        this.editedItem.email = params.row.email
        this.editedItem.cellPhone = params.row.cellPhone
        // this.editedItem.homePhone = params.row.homePhone
        // this.editedItem.workPhone = params.row.workPhone
        this.sendEmail = 'mailto:' + params.row.email
        this.callMobile = 'tel:' + params.row.cellPhone
        // this.callHome = 'tel:' + params.row.homePhone
        // this.callWork = 'tel:' + params.row.workPhone
        this.editedItem.image = params.row.image
        this.editedItem.picture = params.row.picture

        this.viewDialog = true
      }

      // params.row - row object
      // params.column - column object
      // params.rowIndex - index of this row on the current page.
      // params.event - click event
    },

    newItem () {
      this.dialog = true
    },

    editItem (props) {
      this.evalItem = props.row

      // console.log(this.evalItem)
      this.showEvalForm = true
      // let image = new Image()
      // image.setAttribute('crossorigin', 'anonymous')
      // image.src = props.row.picture

      // this.initialImage = image
      // this.croppa.refresh()

      // this.editedIndex = props.index
      // this.editedItem.id = props.row.id
      // this.editedItem.name = props.formattedRow.name
      // this.editedItem.diet = props.formattedRow.diet
      // this.editedItem.count = props.formattedRow.count
      // this.editedItem.image = props.row.image
      // this.editedItem.picture = props.row.picture
      // this.dialog = true
    },

    save () {
      this.editedItem.dataUrl = this.croppa.generateDataUrl('image/jpeg', 0.8)
      // console.log(this.editedItem.dataUrl)

      if (this.editedIndex > -1) {
        // console.log('Update')
        this.updateItem(this.editedItem)
      } else {
        // console.log('Save')
        this.addItem(this.editedItem)
        this.rows.push(this.editedItem)
      }

      this.close()
    },

    deleteItem () {
      let r = confirm('Are you sure you want to delete ' + this.editedItem.name + '?')

      if (r === true) {
        this.rows.splice(this.editedIndex, 1)
        this.removeItem(this.editedItem.id)
      }

      this.close()
    },

    deleteItemList (props) {
      let r = confirm('Are you sure you want to delete ' + props.formattedRow.name + '?')

      if (r === true) {
        this.rows.splice(props.index, 1)
        this.removeItem(props.row.id)
      }
    },

    async saveCommittee () {
      try {
        this.editedCommittee.committeeId = this.committeeHeader.committeeID
        const response = await Api().post('user_committees', this.editedCommittee)

        //   let name = this.committeeList.find(item => item.value === this.editedCommittee.committeeId)
        //   this.loadCommittee.name = name.text
        //   this.loadCommittee.title = this.editedCommittee.title
        //   this.loadCommittee.year = this.currentYear
        //   this.loadCommittee.id = this.editedCommittee.committeeId

        //   this.userCommittees.push(this.loadCommittee)
        //   this.currentCommittees.push(this.loadCommittee)

        //   setTimeout(() => {
        //     this.editedCommittee = Object.assign({}, this.defaultCommittee)
        //     this.loadCommittee = Object.assign({}, this.loadDefaultCommittee)
        //   }, 300)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteCommittee (committeeId) {
      let r = confirm('Are you sure you want to remove this committee?')

      if (r === true) {
        try {
          const response = await Api().delete('user_committees/' + this.editedItem.id + '/' + committeeId)

          this.userCommittees.splice(this.userCommittees.findIndex(obj => obj.id === committeeId), 1)
          this.currentCommittees.splice(this.currentCommittees.findIndex(obj => obj.id === committeeId), 1)

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async getCommittees () {
      this.isCommChair = false

      try {
        const response = await Api().get('get_busters/' + this.currentYear)

        const busterList = response.data

        const busters = []

        for (let i in busterList) {
          busterList[i].birthDate = moment(String(busterList[i].birthDate)).format('MM/DD/YYYY')
          busters.push(busterList)
        }

        this.rows = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async enterEvals () {
      for (let j in this.rows) {
        if (this.rows[j].status !== 'Chair' && !this.rows[j].eval) {
          const editItem = {}

          editItem.evaluator = this.$store.state.user.id
          editItem.CommitteeId = this.committeeHeader.committeeID
          editItem.UserId = this.rows[j].id
          editItem.hours = 0
          editItem.notes = 'No hours because of Rodeo Cancelled.'

          // console.log(editItem)

          try {
            const response = await Api().post('evals', editItem)

            this.rows[j].eval = editItem

            this.snackbar.message = response.data.message
            this.snackbar.color = 'success'
            this.snackbar.show = true
          } catch (error) {
            this.snackbar.message = error.response.data.error
            this.snackbar.color = 'error'
            this.snackbar.show = true
          }
        }
      }
    },

    searchYear () {
      this.currentYear = this.searchType
      this.getCommittees()
    },

    async addItem (item) {
      try {
        const response = await Api().post('animals', item)
        this.editedItem.id = response.data.animal.id
        this.editedItem.image = response.data.animal.image
        this.editedItem.picture = response.data.animal.picture

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem (item) {
      try {
        const response = await Api().put('animals/' + item.id, item)
        this.editedItem.image = response.data.body.image
        this.editedItem.picture = response.data.animal.picture

        let newVal = Object.assign(this.rows[this.editedIndex], this.editedItem)
        this.$set(this.rows, this.editedIndex, newVal)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async buildPdf (itemId) {
      try {
        const response = await Api().delete('animals/' + itemId)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    buildEmail () {
      for (let i in this.rows) {
        this.emailList[i] = this.rows[i].name + ' <' + this.rows[i].email + '>'
      }
      this.ccList = this.emailList
      this.bccList = this.emailList

      for (let i in this.$refs['my-table'].selectedRows) {
        this.emails[i] = this.$refs['my-table'].selectedRows[i].name + ' <' + this.$refs['my-table'].selectedRows[i].email + '>'
      }

      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    onExport () {
      this.printMembers = this.rows.map(a => ({
        'First Name': a.firstName,
        'Last Name': a.lastName,
        'Title': a.title,
        'Email': a.email,
        'Mobile': a.cellPhone
      }))

      let membersWS = XLSX.utils.json_to_sheet(this.printMembers)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Insert Title Here'

      XLSX.utils.book_append_sheet(wb, membersWS, this.committeeHeader.committeeCode)

      XLSX.writeFile(wb, 'committee-' + this.committeeHeader.committeeCode + '.xlsx')
    },

    remove (item) {
      // console.log(item)
      this.emails.splice(this.emails.indexOf(item), 1)
      this.emails = [...this.emails]
    },

    closeThis (item) {
      this.emails = []
      this.showEmailForm = false
    },

    closeThisEval (item) {
      const evalmem = item
      let index = this.rows.findIndex(row => row.id === evalmem.UserId)
      this.rows[index].eval = evalmem
      this.showEvalForm = false
    },

    close () {
      this.initialImage = null
      this.dialog = false
      this.viewDialog = false
      this.showEmailForm = false
      this.showEvalForm = false
      this.qrDialog = false

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/muttonBustin/List.vue